(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_accordion-row"] && !Shopify.designMode) return;
  try {
    // Auto-open accordion when linked via anchor
  function openAccordionFromHash() {
    const hash = window.location.hash;
    if (hash === '#accordion-build-price-options-6tCJwM') {
      setTimeout(() => {
        // Find ALL details elements
        const allDetails = document.querySelectorAll('details.details');
        
        // Loop through and find the one with "Build & Price Options" in the heading
        allDetails.forEach(details => {
          const summary = details.querySelector('summary');
          if (summary && summary.textContent.includes('Build') && summary.textContent.includes('Price')) {
            details.open = true;
            details.setAttribute('open', '');
            
            setTimeout(() => {
              details.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }, 200);
          }
        });
      }, 800);
    }
  }

  window.addEventListener('load', openAccordionFromHash);
  window.addEventListener('hashchange', openAccordionFromHash);
  } catch(e) { console.error(e); }
})();

})();
